/*
 *
 * Error reducer
 *
 */
import produce from 'immer';
import { get } from 'lodash';

import {
  DEFAULT_ACTION,
  SHOW_TOAST,
  HIDE_TOAST,
  RESET_ERROR_TITLE,
  RESET_TWO_FACTOR_VERIFICATION,
} from './constants';

import { AUTHENTICATION_MODALS } from '../../utils/constants';

export const initialState = {
  data: null,
  isOpen: false,
  autoCloseTimer: 8000,
  errorTitle: '',
  isTwoFactorAuthenticated: false,
};

/* eslint-disable default-case, no-param-reassign */
const toastReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case SHOW_TOAST: {
        // checking if authentication is required
        const title = get(action.data, 'errorMeta.title', '');
        const data = get(action.data, 'errorMeta.data', {});
        const className = get(action.data, 'errorMeta.className', '');

        if (title && AUTHENTICATION_MODALS.includes(title)) {
          draft.errorTitle = title;
          draft.errorData = data;
          draft.className = className;
        } else draft.isOpen = true;

        draft.data = action.data;
        break;
      }
      case HIDE_TOAST: {
        if (draft.data?.className) {
          draft.data = { className: draft.data?.className };
        } else {
          draft.data = null;
        }
        draft.isOpen = false;
        break;
      }
      case RESET_ERROR_TITLE: {
        draft.errorTitle = '';
        break;
      }
      case RESET_TWO_FACTOR_VERIFICATION: {
        draft.isTwoFactorAuthenticated = action.data;
        break;
      }
      case DEFAULT_ACTION:
        break;
    }
  });

export default toastReducer;
